<template>
  <div class="public-content task">
    <div class="breadcrumb">{{ formInline.originType == 'BRIDAL' ? '婚纱任务查询' : formInline.originType == 'VIDEO' ? '影像季任务列表' : '任务查询' }}</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="120px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="任务号:">
              <el-input v-model="formInline.orderItemNo" placeholder="请输入任务号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="SKU组名称:">
              <el-select clearable v-model="formInline.skuGroupId" :filter-method="selectSkuGroupList" filterable placeholder="请输入sku组名称">
                <el-option v-for="item in skuGroupList" :key="item.id" :label="item.skuGroupName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="SKU名称:">
              <el-select clearable v-model="formInline.skuId" :filter-method="selectSkuList" filterable placeholder="请输入sku名称">
                <el-option v-for="item in skuList" :key="item.id" :label="item.skuName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-select clearable v-model="formInline.spuId" :filter-method="selectSpuList" filterable placeholder="请输入产品名称">
                <el-option v-for="item in spuList" :key="item.id" :label="item.spuName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称:">
              <el-input v-model="formInline.message" placeholder="请输入客户名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户名:">
              <el-select clearable v-model="formInline.userId" :filter-method="selectUserList" filterable placeholder="请输入用户名">
                <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="任务状态:">
              <el-select v-model="formInline.orderItemStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in orderItemStatusOptions" :label="item.text" :key="item.value" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单类型：">
              <el-select v-model="formInline.channel" clearable placeholder="请选择">
                <el-option label="本店订单" value="B2B" />
                <el-option label="渠道订单" value="B2C" />
                <el-option label="拓客订单" value="B2C" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品类型：">
              <el-select v-model="formInline.itemType" clearable placeholder="请选择">
                <el-option :label="v" :value="k" v-for="(v, k) in $config.productType" :key="k" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="支付方式:">
              <el-select v-model="formInline.paymentType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="微信" value="WXPAY"></el-option>
                <el-option label="支付宝" value="ALIPAY"></el-option>
                <el-option label="余额" value="VPAY"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="支付日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" v-if="$hasPermission('oms:admin:orderItem:list')" round> 查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round v-if="$hasPermission('oms:admin:orderItem:export')">导出Excel</el-button>
            <el-button class="search-ok" @click="exportStatement" round v-if="$hasPermission('oms:admin:orderItem:export')">导出对账单</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column prop="orderItemNo" label="任务号" fixed="left" min-width="100px"></el-table-column>
          <el-table-column prop="orderNo" label="订单号" fixed="left" min-width="210px">
            <template v-slot="scope">
              <span v-if="$hasPermission('oms:admin:order:one')" @click="orderInfo(scope.row)" class="color-blue">{{ scope.row.orderNo }}</span>
              <span v-else>{{ scope.row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="channel" label="订单类型" min-width="150px">
            <template v-slot="scope"> {{ scope.row.channel === 'B2B' ? '本店订单' : scope.row.channel === 'B2C' ? '拓客订单' : '' }} </template>
          </el-table-column>
          <el-table-column prop="itemType" label="产品类型" min-width="150px">
            <template v-slot="scope"> {{ $config.productType[scope.row.itemType] }}</template>
          </el-table-column>
          <!-- <el-table-column prop="skuGroupName" label="SKU组名称" min-width="200"></el-table-column> -->
          <el-table-column prop="skuName" label="SKU名称" min-width="150">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="light" :content="scope.row.skuName" placement="bottom-start">
                <span style="text-overflow: ellipsis;white-space: nowrap;">{{ scope.row.skuName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="spuName" label="产品名称" min-width="150"></el-table-column>
          <el-table-column prop="storeCode" label="平台号" min-width="130"></el-table-column>
          <el-table-column prop="userName" label="用户名" min-width="130"></el-table-column>
          <el-table-column prop="datePayment" label="支付日期" min-width="170"></el-table-column>
          <!-- <el-table-column prop="priceReal" label="任务总价" min-width="80">
            <template slot-scope="scope"> {{ scope.row.paymentType ? ((scope.row.paymentType === 'VPAY' ? scope.row.price : scope.row.onlinePrice) * scope.row.quantity).toFixed(2) : '' }} </template>
          </el-table-column>
          <el-table-column prop="price" label="平台单价" min-width="80">
            <template slot-scope="scope"> {{ scope.row.paymentType ? (scope.row.paymentType === 'VPAY' ? scope.row.price : scope.row.onlinePrice).toFixed(2) : '' }} </template>
          </el-table-column> -->
          <el-table-column prop="page" label="P数" min-width="80"></el-table-column>
          <el-table-column prop="quantity" label="数量" min-width="80"></el-table-column>
          <!-- <el-table-column prop="onlinePrice" label="会员单价" min-width="80"></el-table-column> -->
          <el-table-column label="任务状态" fixed="right" min-width="100">
            <template slot-scope="scope">
              <p class="color-blue" @click="checkTaskLog(scope.row)">{{ $config.orderItemStatus[scope.row.orderItemStatus] }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="客户名称" fixed="right" min-width="200" show-overflow-tooltip>
            <template v-slot="scope">
              <span class="color-blue" v-if="scope.row.orderStatus === 'SUBMITTED' && $hasPermission('oms:admin:suborder:message')" @click="changeMsgShow(scope.row)">{{ scope.row.message !== '????' ?
                scope.row.message : '' }}</span>
              <span v-if="scope.row.orderStatus !== 'SUBMITTED' || !$hasPermission('oms:admin:suborder:message')">{{ scope.row.message !== '????' ? scope.row.message : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="快递追踪" fixed="right" min-width="100px">
            <template v-slot="scope">
              <el-button v-if="scope.row.orderItemStatus === 'SHIPPED' || scope.row.orderItemStatus === 'SIGNED'" @click="getExpressDetail(scope.row.id, $msg.filterBridal(scope.row.userName))"
                type="text" size="small"> 查看快递</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="合成信息" min-width="80" fixed="right">
            <template v-slot="scope">
              <a :href="scope.row.url" style="color:#409EFF">链接</a>
            </template>
          </el-table-column>
          <el-table-column label="合成文件" fixed="right" min-width="100px">
            <template v-slot="scope">
              <el-button v-if="['RENDER_DONE', 'DONE_DOWNLOAD', 'SHIPPED', 'COMPLETED', 'SIGNED'].includes(scope.row.orderItemStatus) && scope.row.itemType !== 'SAMPLE'"
                @click="getRenderPdf(scope.row.orderItemNo)" type="text" size="small">查看合成 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
    <express-dialog ref="expressDialogRef"></express-dialog>
    <el-dialog :close-on-click-modal="false" title="客户名称" :visible.sync="msgShow" width="600px">
      <el-form :model="subOrder" label-width="100px">
        <el-form-item label="客户名称:">
          <el-input v-model="subOrder.suborderId" v-if="false"></el-input>
          <el-input v-model="subOrder.message" autocomplete="off" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="msgShow = false">取 消</el-button>
        <el-button type="primary" @click="changeSuborderMessage">确 定</el-button>
      </div>
    </el-dialog>
    <RenderDialog ref="renderDialogRef"></RenderDialog>
    <TaskLogListDialog ref="TaskLogListDialog"></TaskLogListDialog>
  </div>
</template>
<script>
import TaskLogListDialog from '@/components/Dialog/OrderDialog/TaskLogListDialog/index.vue'
import VPagination from '@/components/Pagination/index.vue'
import ExpressDialog from '@/components/Dialog/ExpressDialog/index'
import { getAllUsersByFullName, getAdminByFullName, getAllUsersByUserName, storeQueryListByCode } from '@/api/crm'
import RenderDialog from '@/components/Dialog/OrderDialog/RenderDialog/index.vue'
import { orderTaskPage, taskExport, statementExport, changeSuborderMessage, getRenderPdf, orderTaskExpress } from '@/api/oms'
import { spuLikeByName, skuGroupLikeByName, skuLikeByName } from '@/api/pms'
export default {
  name: 'task',
  components: {
    TaskLogListDialog,
    VPagination,
    ExpressDialog,
    RenderDialog
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0] + ' 00:00:00'
          this.formInline.dateEnd = val[1] + ' 23:59:59'
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function (newRoute, oldRoute) {
        console.log('当前路由：', newRoute)
        console.log('之前的路由：', oldRoute)
        if (newRoute.path == '/taskHs') {
          this.formInline.originType = 'BRIDAL'
        } else if (newRoute.path == '/taskYxj') {
          this.formInline.originType = 'VIDEO'
        } else {
          this.formInline.originType = ''
        }
        if (oldRoute && (oldRoute.path == '/taskHs' || oldRoute.path == '/taskYxj' || oldRoute.path == '/task')) {
          this.onSubmit()
        }
        this.userList = []
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  data () {
    var _this = this
    return {
      storeListByCode: [],
      skuList: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        originType: '',
        dateEnd: null,
        dateStart: null,
        message: null,
        orderItemNo: null,
        orderItemStatus: null,
        orderNo: null,
        skuId: null,
        skuName: null,
        spuId: null,
        spuName: null,
        storeId: null,
        userName: null,
        itemType: null
      },
      tableData: [],
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      orderItemStatusOptions: [
        {
          value: 'NEW',
          text: '新订单'
        },
        {
          value: 'RENDER_WAIT',
          text: '等待合成'
        },
        {
          value: 'RENDERING',
          text: '合成中'
        },
        {
          value: 'RENDER_DONE',
          text: '合成完成'
        },
        {
          value: 'RENDER_FAILED',
          text: '合成失败'
        },
        {
          value: 'SHIPPED',
          text: '已发货'
        },
        {
          value: 'CANCELLED',
          text: '已取消'
        },
        {
          value: 'SIGNED',
          text: '已签收'
        },
        {
          value: 'AFTERSALESED',
          text: '已售后'
        }
      ],
      msgShow: false,
      subOrder: {
        subOrderId: null,
        message: ''
      },
      userList: [],
      spuList: [],
      skuGroupList: []
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.spuList = JSON.parse(sessionStorage.getItem('spuList'))
      // this.value2[0] = this.formInline.dateStart.split(' ')[0]
      // this.value2[1] = this.formInline.dateEnd.split(' ')[0]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('spuList')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    orderInfo (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('spuList', JSON.stringify(this.spuList))
      this.$router.push({ path: '/orderdetail', query: { orderNo: row.orderNo, way: 1 } })
    },
    selectSkuList (val) {
      if (val.trim()) {
        skuLikeByName(val).then(res => {
          if (res.data.success) {
            this.skuList = res.data.data
          }
        })
      }
    },
    selectSkuGroupList (val) {
      if (val.trim()) {
        skuGroupLikeByName(val).then(res => {
          if (res.data.success) {
            this.skuGroupList = res.data.data
          }
        })
      }
    },
    selectSpuList (val) {
      if (val.trim()) {
        spuLikeByName(val).then(res => {
          if (res.data.success) {
            this.spuList = res.data.data
          }
        })
      }
    },
    selectUserList (val) {
      if (val.trim()) {
        let systemCode = this.formInline.originType == 'BRIDAL' ? 'BRIDAL' : this.formInline.originType == 'VIDEO' ? 'VIDEO' : ''
        getAllUsersByUserName(val, systemCode).then(res => {
          if (res.data.success) {
            this.userList = res.data.data.map(a => {
              if (a.userName) {
                a.userName = this.$msg.filterBridal(a.userName)
              }
              return a
            })
          }
        })
      }
    },
    rowClassName ({
      row,
      rowIndex
    }) {
      row.index = rowIndex
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('spuList', JSON.stringify(this.spuList))
      }
      orderTaskPage({
        params: {
          sort: 'dateCreated,desc',
          page: this.queryInfo.pageNum - 1,
          size: this.queryInfo.pageSize
        },
        data: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.content.map(a => {
            if (a.userName) {
              a.userName = this.$msg.filterBridal(a.userName)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (!param.dateStart) {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD') + ' 00:00:00'
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      taskExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '任务表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    exportStatement () {
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (!param.storeId) {
      //   this.$message.error('请选择平台号')
      //   return false
      // }
      if (!param.dateStart) {
        this.$message.error('请选择支付日期')
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // if (!param.dateStart) {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD') + ' 00:00:00'
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      statementExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          // let _fileName = '对账单' + this.value2[0] + '-' + this.value2[1] + '.xls'
          let _fileName = '对账单' + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    getNewRemark (val) {
      this.tableData[val.index].remark = val.message
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    getExpressDetail (id, phone) {
      orderTaskExpress(id).then(res => {
        if (res.data.success) {
          this.$refs.expressDialogRef.show(res.data.data[0], phone)
        }
      })
    },
    changeSuborderMessage () {
      changeSuborderMessage({
        subOrderId: this.subOrder.subOrderId,
        message: this.subOrder.message
      }).then(res => {
        if (res.data.success === true) {
          this.$message.success('修改收货信息成功')
          this.msgShow = false
          this.onSubmit()
        }
      })
    },
    checkTaskLog (row) {
      this.$refs.TaskLogListDialog.show(row.id, '任务')
    },
    changeMsgShow (row) {
      this.subOrder = {
        message: row.message,
        subOrderId: row.subOrderId
      }
      this.msgShow = true
    },
    getRenderPdf (itemId) {
      this.$refs.renderDialogRef.show(itemId)
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
